import store from '@/store'
import Swal from 'sweetalert2'

/* services */
import ReleasesNotesService from "@/services/ReleasesNotes"

async function saveReleaseNotesData (releases) {
    try {
        let data
        let numberUnreadEntries
        
        // Obtém os releases já salvos no store
        const releasesSavedInStore = store.state.releasesNotes.releases
        // Verifica se releases não está vazio
        const isEmpty = !!releases && Object.keys(releases).length
            
        // Se releases estiver vazia, atualiza o store com os dados recebidos da Api
        if (!releases) {
            data = await ReleasesNotesService.getAllReleases()
            data.forEach(obj => {
                releasesSavedInStore.forEach (obj2 => {
                    if (obj.num_versao === obj2.num_versao) {
                        obj.read = obj2.read
                    }
                })
            })     
            numberUnreadEntries = data.filter(dados => !dados.read)
            
            // Salva os releases atualizados no store
            saveReleasesInStore (data, numberUnreadEntries)
        }
        // Se releases não estiver vazia, atualiza o store com os dados recebidos pela função
        if (isEmpty) {
            const { updatingReleases, releasesUnread } = versionWasRead (releases, releasesSavedInStore)
            data = updatingReleases
            numberUnreadEntries = releasesUnread
            
            // Salva os releases atualizados no store
            saveReleasesInStore (data, numberUnreadEntries)
        }
    } catch (error) {
        errorMessage (error)
    }
}

function versionWasRead (release, releasesSavedInStore) {
    // Atualiza os releases, substituindo aqueles cuja versão foi lida
    const updatingReleases = releasesSavedInStore.map(item => {
        const isVersionRead = release.num_versao === item.num_versao && release.read && Boolean(item.read) === false
        if (isVersionRead) return release
        return item })

    const releasesUnread = updatingReleases.filter(dados => !dados.read)

    return {updatingReleases, releasesUnread}
}

function saveReleasesInStore (data, numberUnreadEntries) {
    // Salva os releases no store e atualiza o contador de não lidos.
    store
        .dispatch('releasesNotes/setSaveReleasesData', { data, unreadCount: numberUnreadEntries.length })
        .then(res =>  res)
        .catch(err => { throw err })
}

function errorMessage (error) {
    const objSwal = {
        error: {
            title: '',
            text: error.message,
            html: ''
        }
    }
    Swal.fire(objSwal.error)
} 

export { saveReleaseNotesData }
